import TransformComponent from '../../Component/Transform';
import Renderable from '../../Component/Renderable';
import GateComponent from '../../Component/World/Gate';
import Interactable from '../../Component/Interactable';
import GameObject from '../../GameObject/GameObject';
import Sprite from '../Sprite';
import Point from '../../Utility/Point';
import SpeechBubble from './SpeechBubble';
import Game from '../../Game';

export default class Gate extends GameObject {
    protected onCreate(params: { x: number; y: number; open: number }): void {
        this.addComponent<TransformComponent>(TransformComponent, params);
        this.addComponent<Renderable>(Renderable, params);
        this.addComponent<GateComponent>(GateComponent, params);

        if (params.open) {
            this.addComponent<Interactable>(Interactable, {
                enabled: true,
                buttonMode: true,
            });
        }

        // Add the base sprite.
        const baseSprite: Sprite = GameObject.Instantiate(Sprite, {
            texture: 'stargate',
            anchor: new Point(0.5, 0.5),
        });
        this.addChild(baseSprite);

        // Add the speech bubble.
        const speechBubble: SpeechBubble = GameObject.Instantiate(
            SpeechBubble,
            {
                x: -10,
                y: -60,
                text: Game.locale.getText(params.open ? 'Open' : 'Close'),
                textStyle: Game.style.getStyle('gate.text'),
                visible: true,
            }
        );
        this.addChild(speechBubble);
    }
}
